import React from 'react';
import { drinkInfo } from './data.scoure';

export default class Drink extends React.Component {
    render() {
        const DNS = "https://organic-naturetea.com/shenglongTest/asset/"
        const info = drinkInfo.data;
        return (
            <div id="drink">
                {info.map(drink => {
                    const { title, rootinfo } = drink;
                    const { description, image, style } = rootinfo;
                    const { className } = style;
                    // "imgdiv sm:imgdivN001" 超雞掰 不會跑sm後面的
                    return (
                        <div class="bg-local drinkbgimg prod prod_d1" key={title}>
                            <div class="prod_con ml-20 mr-20 grid grid-cols-2 xl:ml-64 xl:mr-64 md:grid-cols-1 sm:grid-cols-1">
                                <div class="text-center w-full grid grid-rows-1 sm:grid-rows-1 items-center">
                                    <div class="pt-10 pb-10 xl:pt-0 xl:pb-0">
                                        <p class="text-6xl -ml-12 -mr-12 md:text-5xl sm:text-4xl">{title}</p>
                                        {title === "蟬吃鮮翠烏龍茶"
                                            ? <p class="text-red-600 md:text-lg xl:text-xl">{rootinfo.winword}</p>
                                            : ""}
                                        <br />
                                        <p class="xl:text-2xl md:text-xl whitespace-pre-line -mr-6 -ml-6">{description}</p>

                                        {/* <Link to={"/detail/" + title} class="text-blue-500">點我看更多&gt;&gt;&gt;</Link> */}
                                    </div>
                                </div>
                                <div class={` ${className === "imgdivN001" ? "imgdivN001" : "imgdiv"}  justify-center`} id={image}>
                                    <img src={DNS + image} alt={title} class=" h-auto xl:pt-10 xl:max-w-xl w-6/12 sm:w-5/6" />
                                </div>
                            </div>
                        </div >
                    )
                })}
            </div>
        )
    }
}

// style={{
//     backgroundImage: "url(asset/" + image + ")",
// }}